import React from "react";
import { useNavigate } from "react-router-dom";
import "./AdminAdministration.css";

const accionesAdministrativas = [
  {
    titulo: "Crear usuarios",
    descripcion: "Registra administradores, maestros, alumnos o monitores.",
    ruta: "/create-user",
    categoria: "Usuarios",
  },
  {
    titulo: "Actualizar usuarios",
    descripcion: "Consulta, edita o elimina cuentas existentes.",
    ruta: "/update-user",
    categoria: "Usuarios",
  },
  {
    titulo: "Crear clase",
    descripcion: "Registra una materia y asigna al maestro responsable.",
    ruta: "/create-class",
    categoria: "Clases",
  },
  {
    titulo: "Crear evaluación",
    descripcion:
      "Configura formularios diagnósticos, finales y de satisfacción.",
    ruta: "/create-evaluation",
    categoria: "Clases",
  },
  {
    titulo: "Asignar alumnos",
    descripcion: "Relaciona alumnos con las materias correspondientes.",
    ruta: "/assign-class",
    categoria: "Clases",
  },
  {
    titulo: "Agregar reunión de Zoom",
    descripcion: "Programa una liga de Zoom para una materia.",
    ruta: "/zoom-link",
    categoria: "Clases",
  },
  {
    titulo: "Subir Excel",
    descripcion: "Carga un archivo Excel a la plataforma.",
    ruta: "/upload-excel",
    categoria: "Archivos",
  },
  {
    titulo: "Ver archivos Excel",
    descripcion: "Consulta, descarga o elimina archivos Excel.",
    ruta: "/excel-table",
    categoria: "Archivos",
  },
  {
    titulo: "Subir constancias",
    descripcion: "Carga una constancia PDF para un alumno.",
    ruta: "/create-cert",
    categoria: "Constancias",
  },
  {
    titulo: "Ver constancias",
    descripcion: "Consulta y administra las constancias disponibles.",
    ruta: "/watch-cert",
    categoria: "Constancias",
  },
  {
    titulo: "Crear noticia",
    descripcion: "Publica un aviso institucional para los usuarios.",
    ruta: "/create-news",
    categoria: "Comunicación",
  },
];

const AdminAdministration = () => {
  const navigate = useNavigate();

  return (
    <div className="admin-administration">
      <div className="admin-administration-heading">
        <div>
          <p>Panel administrativo</p>
          <h2>¿Qué deseas administrar?</h2>
        </div>
        <span>{accionesAdministrativas.length} herramientas</span>
      </div>

      <div className="admin-administration-grid">
        {accionesAdministrativas.map((accion) => (
          <article className="admin-administration-card" key={accion.ruta}>
            <span className="admin-administration-category">
              {accion.categoria}
            </span>
            <h3>{accion.titulo}</h3>
            <p>{accion.descripcion}</p>
            <button type="button" onClick={() => navigate(accion.ruta)}>
              Abrir herramienta
            </button>
          </article>
        ))}
      </div>
    </div>
  );
};

export default AdminAdministration;
